(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battlezone-product-showcase"] && !Shopify.designMode) return;
  try {
    
  class BattlezoneShowcase extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-battlezone-play]').forEach((button) => {
        button.addEventListener('click', () => this.playAssociatedVideo(button));
      });
    }

    playAssociatedVideo(button) {
      const row = button.closest('.battlezone-showcase__video-row');
      const video = row?.querySelector('.battlezone-showcase__video');
      const poster = row?.querySelector('.battlezone-showcase__poster-button');

      if (!video) return;

      poster?.classList.add('is-hidden');
      video.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (video.tagName === 'VIDEO') {
        video.controls = true;
        video.play?.();
        return;
      }

      if (video.tagName === 'IFRAME') {
        const currentSrc = video.getAttribute('src');
        if (!currentSrc) return;

        try {
          const url = new URL(currentSrc, window.location.origin);
          url.searchParams.set('autoplay', '1');
          url.searchParams.set('mute', '0');
          video.setAttribute('src', url.toString());
        } catch (error) {
          const separator = currentSrc.includes('?') ? '&' : '?';
          video.setAttribute('src', `${currentSrc}${separator}autoplay=1`);
        }
      }
    }
  }

  if (!customElements.get('battlezone-showcase')) {
    customElements.define('battlezone-showcase', BattlezoneShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
